import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'AFFILIATION_UPDATE',
    smsDelete : 'AFFILIATION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        affiliation: [],
        affiliation_detail: {},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        affiliationLoading: false,
        affiliationError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_AFFILIATION(state, affiliation) {
            state.affiliation = affiliation;
        },

        SET_AFFILIATION_DETAIL(state, detail) {
            state.affiliation_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        AFFILIATION_LOADING (state, loading) {
            state.affiliationLoading = loading;
        },

        AFFILIATION_ERROR (state, hasError) {
            state.affiliationError = hasError;
        }
    },

    actions: {
        // Affiliation
        async addAffiliation ({commit, dispatch}, payload) {
            commit('AFFILIATION_LOADING', true);
            commit('AFFILIATION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.create_affiliation, payload.affiliation, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAffiliation')
                return response

            } catch (e) {
                commit('AFFILIATION_ERROR', true);
            } finally {
                commit('AFFILIATION_LOADING', false);
            }
        },

        async fetchAffiliationDetail ({ commit },payload) {
            commit('AFFILIATION_LOADING', true);
            commit('AFFILIATION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_affiliation_details + payload, config);
                let response = result.data.data
                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('AFFILIATION_ERROR', true);
            } finally {
                commit('AFFILIATION_LOADING', false);
            }
        },

        async fetchAffiliation ({ commit }) {
            commit('AFFILIATION_LOADING', true);
            commit('AFFILIATION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.affiliation_list, config);
                let response = result.data
                commit('SET_AFFILIATION', response.data);

            } catch(error) {
                commit('AFFILIATION_ERROR', true);
            } finally {
                commit('AFFILIATION_LOADING', false);
            }
        },

        async updateAffiliation ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_affiliation+payload.id, payload.affiliation, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAffiliation')
                return response

            } catch (e) {
                commit('AFFILIATION_ERROR', true);
            } finally {
                commit('AFFILIATION_LOADING', false);
            }
        },
        
        async deleteAffiliation({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.affiliation_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAffiliation')
            return response
        }
    },

    getters: {}
}
